import React from 'react';
import styled, { keyframes } from 'styled-components';

const StatsSection = styled.section`
  display: flex;
  align-items: center;
  font-family: Very Sans, Sans Serif;
  padding-bottom: 6rem;
  @media screen and (max-width: 768px) {
  display: none;
  }
`;

const StatsContainer = styled.div`
  width: 80%;
  text-align: center;
  margin: 0 auto;
`;

const SectionTitleRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 500;
  margin-bottom: 24px;
  color: white;
  font-family: Very Sans Headline, Sans Serif;
`;

// Marquee animation keyframes
const marqueeLeft = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const marqueeRight = keyframes`
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
`;

const MarqueeWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const MarqueeContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const MarqueeContent = styled.div`
  display: flex;
  animation: ${props => props.$reverse ? marqueeRight : marqueeLeft} 40s linear infinite;
  gap: 1rem;
  align-items: center;
  width: fit-content;
`;

const ProjectCard = styled.div`
  flex-shrink: 0;
  width: 280px;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(59, 130, 246, 0.3);
    transform: translateY(-4px);
  }
`;

const ProjectCategory = styled.div`
  color: #3B82F6;
  font-size: 12px;
  font-weight: 400;
  text-transform: capitalize;
  font-family: Very Sans, Sans Serif;
`;

const ProjectName = styled.div`
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  font-family: Very Sans Bold, Sans Serif;
`;

const Stats = () => {
  const topRowProjects = [
    { category: 'Bridge', name: 'HydrixBridge' },
    { category: 'Governance', name: 'HydrixDAO' },
    { category: 'Payments', name: 'HydrixPay' },
    { category: 'Staking', name: 'HydrixVault' },
    { category: 'Tools', name: 'HydrixExplorer' },
    { category: 'DeFi', name: 'HydrixSwap' },
    { category: 'Lending', name: 'HydrixLend' }
  ];

  const bottomRowProjects = [
    { category: 'Marketplace', name: 'HydrixNFT' },
    { category: 'DeFi', name: 'HydrixLend' },
    { category: 'Bridge', name: 'HydrixBridge' },
    { category: 'Governance', name: 'HydrixDAO' },
    { category: 'Payments', name: 'HydrixPay' },
    { category: 'Staking', name: 'HydrixVault' },
    { category: 'Wallet', name: 'HydrixWallet' }
  ];

  return (
    <StatsSection>
      <StatsContainer>
        <SectionTitleRow>
          <SectionTitle>Hydrix Ecosystem</SectionTitle>
        </SectionTitleRow>
        
        <MarqueeWrapper>
          {/* First Marquee - Moving Left */}
          <MarqueeContainer>
            <MarqueeContent>
              {topRowProjects.map((project, index) => (
                <ProjectCard key={`top-${index}`}>
                  <ProjectCategory>{project.category}</ProjectCategory>
                  <ProjectName>{project.name}</ProjectName>
                </ProjectCard>
              ))}
              {/* Duplicate for seamless loop */}
              {topRowProjects.map((project, index) => (
                <ProjectCard key={`top-dup-${index}`}>
                  <ProjectCategory>{project.category}</ProjectCategory>
                  <ProjectName>{project.name}</ProjectName>
                </ProjectCard>
              ))}
            </MarqueeContent>
          </MarqueeContainer>

          {/* Second Marquee - Moving Right */}
          <MarqueeContainer>
            <MarqueeContent $reverse>
              {bottomRowProjects.map((project, index) => (
                <ProjectCard key={`bottom-${index}`}>
                  <ProjectCategory>{project.category}</ProjectCategory>
                  <ProjectName>{project.name}</ProjectName>
                </ProjectCard>
              ))}
              {/* Duplicate for seamless loop */}
              {bottomRowProjects.map((project, index) => (
                <ProjectCard key={`bottom-dup-${index}`}>
                  <ProjectCategory>{project.category}</ProjectCategory>
                  <ProjectName>{project.name}</ProjectName>
                </ProjectCard>
              ))}
            </MarqueeContent>
          </MarqueeContainer>
        </MarqueeWrapper>
      </StatsContainer>
    </StatsSection>
  );
};

export default Stats;